import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { CommonResponse } from '../models/responses/common-response';
import { map, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class InspectionResultService {
	constructor(private requestService: RequestService) { }

	getResults(data?: any): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(`/inspection-result`, {
			data,
			option: {
				is_loading: true,
			},
		});
	}

	getByID(id?: string): Observable<CommonResponse<any>> {
		return this.requestService.getJSON(`/inspection-result/${id}`, {
			data: {},
			option: {
				is_loading: true,
			},
		});
	}

	getAttachment(id: string): Observable<Blob> {
		return this.requestService.get(
			`/inspection-result/attachment/${id}`,
			{
				data: null,
				option: {
					is_loading: true,
				},
			},
			'blob'
		);
	}

	uploadDocument(files: FileList, type: any): Observable<CommonResponse<any>> {
		let data = new FormData();
		for (let i = 0; i < files.length; i++) {
			data.append('file', files[i]);
		}
		data.append('type', type);
		return this.requestService.postData('/inspection-result/attachment', {
			data: data,
			option: {
				is_loading: true,
			},
		});
	}

	save(payload: any): Observable<CommonResponse<any>> {
		return this.requestService.postJSON('/inspection-result/save', {
			data: payload,
			option: {
				is_loading: true,
				is_snack_bar: true,
			},
		});
	}

	returnToInspection(payload: any): Observable<CommonResponse<any>> {
		return this.requestService.postJSON('/inspection-result/return-to-inspection', {
			data: payload,
			option: {
				is_loading: true,
				is_snack_bar: true,
			},
		});
	}

	getTracking(id: string): Observable<CommonResponse<any>> {
		return this.requestService.getJSON(`/inspection-result/${id}/history`, {
			data: {},
			option: {
				is_loading: false,
			},
		});
	}

	getRecords(resultId: string): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(
			`/inspection-result/records`,
			{
				data: {
					result_id: resultId,
				},
				option: {
					is_loading: true,
				},
			}
		);
	}

	getRecordByID(id: string): Observable<CommonResponse<any>> {
		return this.requestService.getJSON(`/inspection-result/record/${id}`, {
			data: {},
			option: {
				is_loading: true,
			},
		});
	}

	deleteDocument(id: string, loading = true) {
		return this.requestService.deleteJSON(`/inspection-result/attachment/${id}`, {
			option: {
				is_loading: loading,
			},
		}).pipe(map((response) => {
			const data = Object.assign(response, { data: { _id: id } });
			return data;
		}));
	}

	getInspectionAttachment(code: string, is_loading = true): Observable<Blob> {
		return this.requestService.get(
			`/inspection-result/briefing-note/attachment`,
			{
				data: {
					victim_code: code
				},
				option: {
					is_loading: is_loading,
				},
			},
			'blob'
		);
	}

	uploadReturnDocument(files: FileList, type: any): Observable<CommonResponse<any>> {
		let data = new FormData();
		for (let i = 0; i < files.length; i++) {
			data.append('file', files[i]);
		}
		data.append('type', type);
		return this.requestService.postData('/inspection-result/return-attachment', {
			data: data,
			option: {
				is_loading: true,
			},
		});
	}

	getReturnAttachment(id: string): Observable<Blob> {
		return this.requestService.get(
			`/inspection-result/return-attachment/${id}`,
			{
				data: null,
				option: {
					is_loading: true,
				},
			},
			'blob'
		);
	}

	deleteReturnDocument(id: string, loading = true) {
		return this.requestService.deleteJSON(`/inspection-result/return-attachment/${id}`, {
			option: {
				is_loading: loading,
			},
		}).pipe(map((response) => {
			const data = Object.assign(response, { data: { _id: id } });
			return data;
		}));
	}
	approve(id: string): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(`/inspection-result/${id}/approve`, {
			data: {},
			option: {
				is_loading: true,
				is_snack_bar: true,
			},
		});
	}

	getInsSupportingAttachments(code: string, is_loading = true): Observable<CommonResponse<any>> {
		return this.requestService.getJSON(
			`/inspection-result/briefing-note/supporting-attachment`,
			{
				data: {
					victim_code: code
				},
				option: {
					is_loading: is_loading,
				},
			}
		);
	}

	getCompletedCount(): Observable<CommonResponse<any>> {
		return this.requestService.getJSON(`/inspection-result/count-completed`, {
			option: {
				is_loading: false,
			},
		});
	}

	getSpecificSupportingAttachment(id: string, is_loading = true): Observable<Blob> {
		return this.requestService.get(
			`/inspection-result/briefing-note/supporting-attachment/${id}`,
			{
				data: {},
				option: {
					is_loading: is_loading,
				},
			},
			'blob'
		);
	}
}
